import * as React from 'react'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions'

import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import {
    dataSourceSetFetchFiltersParametersAction,
    selectIsDataSourceDataFetched,
    selectIsDataSourceInitialized,
} from '../../../../data-source'
import { Translate } from '../../../../localization'
import { fetchListDataThunk, selectDataSourceId } from '../../../../configurable-list'
import { BoundThunk } from '../../../../generic-state'
import styled from '@emotion/styled'

const StyledPaper = styled(Paper)`
    margin-bottom: 8px;
`

// eslint-disable-next-line no-shadow
enum ETabValues {
    Hyvaksymatta = 'Hyvaksymatta',
    Hyvaksytyt = 'Hyvaksytyt',
    Kasitellyt = 'Kasitellyt',
    Kaikki = 'Kaikki',
}
// eslint-disable-next-line no-shadow
enum EHyvaksyntaStatusValues {
    Hyvaksymatta = 1,
    Hyvaksytyt = 2,
    Kasitellyt = 3,
}

const getHyvaksyntaStatusValueForTab = (newSelectedTab: ETabValues) => {
    switch (newSelectedTab) {
        case ETabValues.Hyvaksymatta:
            return [EHyvaksyntaStatusValues.Hyvaksymatta]
        case ETabValues.Hyvaksytyt:
            return [EHyvaksyntaStatusValues.Hyvaksytyt]
        case ETabValues.Kasitellyt:
            return [EHyvaksyntaStatusValues.Kasitellyt]
        case ETabValues.Kaikki:
        default:
            return [
                EHyvaksyntaStatusValues.Hyvaksymatta,
                EHyvaksyntaStatusValues.Hyvaksytyt,
                EHyvaksyntaStatusValues.Kasitellyt,
            ]
    }
}

interface IOwnProps {
    listId: string
}

interface IStateProps {
    isDataSourceInitialised: boolean
    dataSourceId: string
    isDataFetched: boolean
}

interface IDispatchProps {
    dataSourceSetFetchParameters: typeof dataSourceSetFetchFiltersParametersAction
    fetchListData: BoundThunk<typeof fetchListDataThunk>
}

interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

const HyvaksyntastatusTabsUnconnected: React.FunctionComponent<IProps> = ({
    dataSourceId,
    isDataSourceInitialised,
    dataSourceSetFetchParameters,
    isDataFetched,
    fetchListData,
    listId,
}) => {
    const [selectedTab, setSelectedTab] = useState(ETabValues.Hyvaksymatta)
    const [fetchDataOnTabChange, setFetchDataOnTabChange] = useState(false)

    useEffect(() => {
        if (!isDataSourceInitialised) {
            return
        }

        const hyvaksyntaStatukset = getHyvaksyntaStatusValueForTab(selectedTab)
        dataSourceSetFetchParameters(dataSourceId, { hyvaksyntaStatukset })

        if (isDataFetched && fetchDataOnTabChange) {
            fetchListData(listId, { resetSelected: true, resetOffset: true })
        }
    }, [
        dataSourceSetFetchParameters,
        dataSourceId,
        isDataSourceInitialised,
        selectedTab,
        isDataFetched,
        fetchListData,
        listId,
        fetchDataOnTabChange,
    ])

    const handleChange = (event: React.ChangeEvent<unknown>, newSelectedTab: ETabValues) => {
        setSelectedTab(newSelectedTab)

        if (isDataFetched) {
            setFetchDataOnTabChange(true)
        }
    }

    return (
        <StyledPaper>
            <Translate
                translate={{
                    hyvaksymatta: 'palkkahallinto.VuorotJaVapaat.HyvaksyntastatusTabs.Label.hyvaksymatta',
                    hyvaksytyt: 'palkkahallinto.VuorotJaVapaat.HyvaksyntastatusTabs.Label.hyvaksytyt',
                    kasitellyt: 'palkkahallinto.VuorotJaVapaat.HyvaksyntastatusTabs.Label.kasitellyt',
                    kaikki: 'palkkahallinto.VuorotJaVapaat.HyvaksyntastatusTabs.Label.kaikki',
                }}
            >
                {({ hyvaksymatta, hyvaksytyt, kasitellyt, kaikki }) => (
                    <Tabs indicatorColor="primary" onChange={handleChange} textColor="primary" value={selectedTab}>
                        <Tab label={hyvaksymatta} value={ETabValues.Hyvaksymatta} />
                        <Tab label={hyvaksytyt} value={ETabValues.Hyvaksytyt} />
                        <Tab label={kasitellyt} value={ETabValues.Kasitellyt} />
                        <Tab label={kaikki} value={ETabValues.Kaikki} />
                    </Tabs>
                )}
            </Translate>
        </StyledPaper>
    )
}

const mapStateToProps = (state: RootState, { listId }: IOwnProps) => {
    const dataSourceId = selectDataSourceId(state, listId)

    return {
        dataSourceId,
        isDataSourceInitialised: selectIsDataSourceInitialized(state, dataSourceId),
        isDataFetched: selectIsDataSourceDataFetched(state, dataSourceId),
    }
}

const mapDispatchToProps = {
    dataSourceSetFetchParameters: dataSourceSetFetchFiltersParametersAction,
    fetchListData: fetchListDataThunk,
}

export default connect(mapStateToProps, mapDispatchToProps)(HyvaksyntastatusTabsUnconnected)
